import React from "react";

const Input = React.forwardRef(
  (
    {
      name,
      label,
      required,
      errorMsg,
      textCenter,
      className,
      type,
      inputClass = "",

      ...rest
    },
    ref
  ) => {
    return (
      <div className={className}>
        <label
          htmlFor={name}
          className="block text-sm font-medium text-slate-700"
        >
          {label}
          <span className={`text-error`}>{required && "*"}</span>
        </label>
        <input
          name={name}
          className={
            `mt-1 block w-full rounded-lg border-slate-300 px-3 py-2 pr-12 text-slate-900 shadow-sm transition duration-200 placeholder:text-slate-400 hover:border-slate-400 focus:border-blue-600 focus:ring-4 focus:ring-blue-600/15 disabled:cursor-not-allowed disabled:bg-slate-100 disabled:text-slate-500 sm:text-sm ${
              textCenter && "text-center"
            } ` + inputClass
          }
          {...rest}
          type={type}
          ref={ref}
        />
        {errorMsg && (
          <span className="mt-1 text-xs font-semibold text-error">
            {errorMsg.split("\n").map((text, index) => (
              <React.Fragment key={index}>
                {text}
                <br />
              </React.Fragment>
            ))}
          </span>
        )}
      </div>
    );
  }
);

export default Input;
